import { Card, CardContent, Skeleton, Stack } from "@mui/material";

const SkeletonCards = ({ count = 3 }) => {
  return (
    <Stack spacing={3}>
      {[...Array(count)].map((_, i) => (
        <Card key={i} sx={{ borderRadius: 3, boxShadow: 4, minWidth: 300 }}>
          <CardContent>
            {/* Skeleton para título */}
            <Skeleton variant="text" width="60%" height={30} sx={{ mb: 2 }} />
            {/* Skeletons para documentos: simulo 3 documentos */}
            {[...Array(3)].map((__, j) => (
              <Stack
                key={j}
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{ mb: 1 }}
              >
                <Skeleton variant="text" width="40%" height={20} />
                <Skeleton
                  variant="rectangular"
                  width={60}
                  height={24}
                  sx={{ borderRadius: 1 }}
                />
                <Skeleton variant="text" width="25%" height={20} />
              </Stack>
            ))}
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
};

export default SkeletonCards;
